import PageLoader from 'Components/Atoms/Loader/PageLoader/PageLoader';
import Courses from 'Components/Organisms/Courses/Courses';
import Educations from 'Components/Organisms/Educations/Educations';
import EntityPublications from 'Components/Organisms/Entity/EntityPublications/EntityPublications';
import Projects from 'Components/Organisms/Projects/Projects';
import WorkExperiences from 'Components/Organisms/WorkExperiences/WorkExperiences';
import DetailedTemplate from 'Components/Templates/Page/Detailed/DetailedTemplate';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { TabProvider } from 'Services/Tab/TabContext';
import { StoreState } from 'Store/Reducers';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntityByName, isEntityLoading } from 'Store/Settings/Entities/Selectors';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import { isFieldsLoading } from 'Store/Settings/Fields/Selectors';
import { fetchLayouts } from 'Store/Settings/Layout/Actions';
import { isLayoutLoading } from 'Store/Settings/Layout/Selectors';

const CandidatePage = ({
    entity,

    isFieldsFetching,
    isEntitiesFetching,
    isLayoutsFetching,

    ...props
}: CandidatePageProps) => {
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        props.fetchEntities();
        props.fetchLayouts();
        props.fetchFields();
    }, []);

    return <TabProvider>
        <PageTemplate>
            <Helmet>
                <title>
                    Kandidaat - Growing People B.V.
                </title>
            </Helmet>

            {
                !id
                ? <PageLoader description='Record id laden...' />
                : isEntitiesFetching
                ? <PageLoader description='Layouts laden...' />
                : isLayoutsFetching
                ? <PageLoader description='Entiteiten laden...' />
                : isFieldsFetching
                ? <PageLoader description='Velden laden...' />
                : <DetailedTemplate
                    entity_name={entity?.name}
                    record_id={id}
                    sidebar={<>
                        <EntityPublications
                            entity_id={entity.id}
                            record_id={id}
                        />
                    </>}
                >
                    <WorkExperiences entity_id={id} />
                    <Educations entity_id={id} />
                    <Courses entity_id={id} />
                    <Projects entity_id={id} />
                </DetailedTemplate>
            }
        </PageTemplate>
    </TabProvider>;
}

interface Props {
    children: any
    entity_id: string
    record_id: string
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityByName(state, 'candidate'),

    isEntitiesFetching: isEntityLoading(state),
    isLayoutsFetching: isLayoutLoading(state),
    isFieldsFetching: isFieldsLoading(state)
});

const mapDispatch = {
    fetchEntities,
    fetchLayouts,
    fetchFields
};

type CandidatePageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(CandidatePage);